module.exports = __webpack_public_path__ + "img/home-preview-ja.285efd13.png";